module.exports = __webpack_public_path__ + "img/detail6.de806529.jpg";